<script>

import axios from 'axios';

export default class IbgeRepository{
    
    async getGeoData(page){
        
        const baseURL = page
        const response = await axios.get(baseURL);
        return response;

    }

}
</script>
